import { IntegrationCard } from '..';

import { useState } from 'react';

import { MESSAGE_STATE_ERROR, MESSAGE_STATE_SUCCESS } from 'constants/message-app-state-contants';
import { useOAuth } from 'hooks/oauth';
import { useTranslation } from 'react-i18next';

export const GreenhouseIntegration = ({
  integration,
  config,
  connect = () => {},
  disconnect = () => {},
  setLoading = () => {},
  popUpMessage = () => {},
}) => {
  const { t } = useTranslation();

  const [enabled, setEnabled] = useState(integration.enabled);

  const onConnect = async code => {
    setLoading(true);
    const { payload } = await connect({ code });

    // Trust the API's enabled flag, not just the absence of a Redux error:
    // OAuth can succeed while webhook registration fails, in which case the
    // backend reports greenhouse.enabled = false and the toggle must stay off.
    const isEnabled = !payload?.error && !!payload?.greenhouse?.enabled;

    if (isEnabled) {
      popUpMessage(
        t('components.integrations.greenhouse.integration.success'),
        MESSAGE_STATE_SUCCESS,
      );
    } else {
      popUpMessage(t('components.integrations.greenhouse.integration.failed'), MESSAGE_STATE_ERROR);
    }

    setEnabled(isEnabled);
    setLoading(false);
  };

  const onConnectError = ({ error, errorDescription }) => {
    popUpMessage(
      t('components.integrations.greenhouse.integration.error', { error, errorDescription }),
      MESSAGE_STATE_ERROR,
    );
  };

  const openAuth = useOAuth({
    authUri: 'https://auth.greenhouse.io/authorize',
    clientId: process.env.REACT_APP_GREENHOUSE_CLIENT_ID,
    responseType: 'code',
    redirectUri: `${process.env.REACT_APP_WEB_URL}/assets/greenhouse_callback.html`,
    scope:
      'harvest:applications:update harvest:applications:list harvest:custom_fields:list harvest:candidates:update harvest:candidates:list harvest:users:list harvest:notes:create harvest:webhooks:create harvest:webhooks:destroy harvest:webhooks:list',
    callbackAction: 'greenhouse_callback',
    callback: onConnect,
    onError: onConnectError,
  });

  const toggleIntegration = async e => {
    const value = e.target.checked;
    if (integration.enabled === value) return;

    if (value) {
      openAuth();
    } else {
      setLoading(true);
      const { payload } = await disconnect();

      // The integration always turns off here, but when Greenhouse rejected the
      // deletion (typically a revoked authorization) its webhook is still live and
      // has to be removed there by hand.
      if (payload?.webhooks_removed === false) {
        popUpMessage(
          t('components.integrations.greenhouse.integration.webhookNotRemoved'),
          MESSAGE_STATE_ERROR,
        );
      }

      setLoading(false);
      setEnabled(false);
    }
  };

  return <IntegrationCard {...config} enabled={enabled} onToggle={toggleIntegration} />;
};
